<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <ul>
            <li v-for="item in XxydList" :key="item.id" class="li-item">
              <div
                v-if="item.outerSiteUrl == null"
                class="licontent"
                @click="goDetail(item.id)"
              >
                <div class="group_news_left">
                  <h2 class="group_news_title">{{ item.title }}</h2>
                  <!-- <h4>111</h4> -->
                  <div class="content" v-if="item.showContent">
                    {{ item.showContent }}
                  </div>
                </div>
                <div class="group_news_right">
                  <div class="group_news_right">{{ item.createTime }}</div>
                  <div class="group_news_right_j">
                    <img src="@/assets/images/icon_h_youjiantou.png" alt="" />
                  </div>
                </div>
              </div>
              <a
                :href="item.outerSiteUrl"
                v-if="item.isOuterSite == 0 && item.outerSiteUrl"
                target="_blank"
              >
                <div class="group_news_left">
                  <h2 class="group_news_title">{{ item.title }}</h2>
                  <!-- <h4>111</h4> -->
                  <div class="content" v-if="item.showContent">
                    {{ item.showContent }}
                  </div>
                </div>
                <div class="group_news_right">
                  <div class="group_news_right">{{ item.createTime }}</div>
                  <div class="group_news_right_j">
                    <img src="@/assets/images/icon_h_youjiantou.png" alt="" />
                  </div>
                </div>
              </a>
            </li>
          </ul>
          <div class="block" v-if="XxydList.length > 0">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage1"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "",
  components: {},
  props: {
    id: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      list: [],
      currentPage4: 1,
      pagination: {
        pagingData: [10, 50, 100, 200],
        total: 0,
        currentPage: 1,
        show: true,
      },
      search: {
        page: 1,
        size: 10,
      },
      currentPage1: 1,
      XxydList: [],
      ysglPage: '',
    };
  },
  computed: {},
  watch: {
    // search: {
    //   handler: function (newValue, oldValue) {
    //     console.log(newValue, oldValue);
    //     if (this.index1 == 1) {
    //       this.getDjgzList();
    //     } else {
    //       // this.getXxydList();
    //     }
    //   },
    //   deep: true,
    // },
  },
  created() {
    this.ysglPage = JSON.parse(localStorage.getItem("ysglPage"));
    // console.log(this.ysglPage,8888);
    if(!this.ysglPage){
       this.ysglPage=1
    }
    this.currentPage1 = this.ysglPage;
    this.pagination.currentPage = this.ysglPage;
    this.search.page = this.ysglPage;
    this.getJlppList();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    getJlppList() {
      let params = {
        pageNum: this.search.page,
        pageSize: this.search.size,
        menuId: 30,
      };
      axios.get("/jtg/home/articleList", { params }).then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        this.XxydList = res.data.items;
        // console.log(res.data, 222);
        this.pagination.total = res.data.total;
        // console.log(res.data, 7777);
      });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.search.size = val;

      this.pagination.currentPage = 1;
      this.currentPage1 = 1;
      this.search.page = 1;
      this.getJlppList();
    },

    handleCurrentChange(val) {
      // console.log(val,77777);

      let x = document.getElementById("app");
      x.scrollTop = 0;
      this.pagination.currentPage = val;
      this.currentPage1 = val;
      this.search.page = val;
      this.getJlppList();
    },
    goDetail(id) {
      // this.$router.push("/bannerDetail?index=" + id);
      this.$router.push({
        path: "/ysgkDetail",
        query: { index: id, ysglPage: this.currentPage1},
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 0px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      min-height: 500px;
      .block {
        margin: -45px 0 20px 0;
        text-align: center;
      }
      .li-item {
        width: 100%;
        height: 202px;
        background: #ffffff;
        border-bottom: 1px solid #e5e5e5;
        padding: 48px 103px 20px 40px;
        box-sizing: border-box;
        a {
          width: 100%;
          height: 100%;
          display: block;
          .group_news_left {
            float: left;
            width: 80%;
            .group_news_title {
              font-size: 18px;
              font-weight: bold;
              color: #333333;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          .group_news_right {
            float: right;
            font-size: 24px;
            font-weight: 400;
            color: #999999;
            .group_news_right_j {
              line-height: 26px;
              margin-top: 60px;
            }
          }
        }
      }
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;
        .head {
          border-bottom: 1px #444 dashed;
          height: 500px;
        }
      }
      .text {
        text-indent: 45px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>